import { Button } from '../../../components/ui/button';
import { FileText, Shield, Save } from 'lucide-react';
import RichTextEditor from '../../common/RichTextEditor';

export default function CMSLegalTab({
  termsContent,
  setTermsContent,
  termsLastUpdated,
  privacyContent,
  setPrivacyContent,
  privacyLastUpdated,
  isSaving,
  onSaveTerms,
  onSavePrivacy
}) {
  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    return new Date(dateStr).toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div className="space-y-6">
      {/* Terms and Conditions */}
      <div className="bg-white rounded-2xl p-6 shadow-sm" data-testid="terms-section">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <FileText className="w-5 h-5 text-amber-600" />
            <div>
              <h3 className="font-bold text-slate-900 font-[Poppins]">Terms and Conditions</h3>
              <p className="text-sm text-slate-500">Legal terms users must accept during signup</p>
              {termsLastUpdated && (
                <p className="text-xs text-slate-400 mt-1">
                  Last updated: {formatDate(termsLastUpdated)}
                </p>
              )}
            </div>
          </div>
          <Button
            onClick={onSaveTerms}
            disabled={isSaving}
            className="bg-amber-500 hover:bg-amber-600 text-slate-900"
            data-testid="save-terms-btn"
          >
            <Save className="w-4 h-4 mr-2" />
            {isSaving ? 'Saving...' : 'Save Terms'}
          </Button>
        </div>
        <RichTextEditor
          value={termsContent}
          onChange={setTermsContent}
          placeholder="Enter your Terms and Conditions..."
        />
      </div>

      {/* Privacy Policy */}
      <div className="bg-white rounded-2xl p-6 shadow-sm" data-testid="privacy-section">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <Shield className="w-5 h-5 text-amber-600" />
            <div>
              <h3 className="font-bold text-slate-900 font-[Poppins]">Privacy Policy</h3>
              <p className="text-sm text-slate-500">How you collect, use, and protect user data</p>
              {privacyLastUpdated && (
                <p className="text-xs text-slate-400 mt-1">
                  Last updated: {formatDate(privacyLastUpdated)}
                </p>
              )}
            </div>
          </div>
          <Button
            onClick={onSavePrivacy}
            disabled={isSaving}
            className="bg-amber-500 hover:bg-amber-600 text-slate-900"
            data-testid="save-privacy-btn"
          >
            <Save className="w-4 h-4 mr-2" />
            {isSaving ? 'Saving...' : 'Save Privacy Policy'}
          </Button>
        </div>
        <RichTextEditor
          value={privacyContent}
          onChange={setPrivacyContent}
          placeholder="Enter your Privacy Policy..."
        />
      </div>
    </div>
  );
}
